export const EMPLOYEE_ID_MATCH = {
  FOUND: 'found',
  NOT_FOUND: 'notFound',
  AMBIGUOUS: 'ambiguous',
};

const digitsOnly = (value) => {
  return String(value).replace(/\D/g, '');
};

/**
 * Find the operator whose ERP employee ID was entered on the PIN pad.
 *
 * An exact match on `erpId` wins. Otherwise, because the pad can only enter
 * digits, the entry is compared with each `erpId` stripped to its digits (so
 * `1234` finds `E-1234`). More than one match at either step is ambiguous
 * rather than a guess.
 *
 * @param {Array<{erpId?: string}>} operators
 * @param {string} employeeId
 * @returns {{ status: string, operator?: Object }}
 */
export const findOperatorByEmployeeId = (operators, employeeId) => {
  const entered = String(employeeId || '').trim();
  const candidates = (operators || []).filter((operator) => {
    return operator?.erpId != null && String(operator.erpId).trim() !== '';
  });

  const resolve = (matches) => {
    if (matches.length === 1) {
      return { status: EMPLOYEE_ID_MATCH.FOUND, operator: matches[0] };
    }
    return matches.length > 1 ? { status: EMPLOYEE_ID_MATCH.AMBIGUOUS } : null;
  };

  const exact = resolve(
    candidates.filter((operator) => {
      return String(operator.erpId).trim() === entered;
    })
  );
  if (exact) return exact;

  const enteredDigits = digitsOnly(entered);
  const byDigits = enteredDigits
    ? resolve(
        candidates.filter((operator) => {
          return digitsOnly(operator.erpId) === enteredDigits;
        })
      )
    : null;

  return byDigits || { status: EMPLOYEE_ID_MATCH.NOT_FOUND };
};
